import { Link } from 'react-router-dom';
import styles from './product.module.scss';
import { Badge } from 'reactstrap';
import { useState, useEffect } from 'react';
import useConvertDate from '../../../utils/hooks/useConvertDate';
import Favorite from '../../../../pages/ProductPage/Featured/Favorite';

const Product = (props)=>{
    const [status, setStatus] = useState(props.data.status);
    const [badgeColor, setBadgeColor] = useState();

    const expireDate = useConvertDate({date: props.data.expire_date,withHour: false});
    // const expireDate = (props.data.expire_date).slice(0,10);

    useEffect(() => {
        if(status == 'PENDING'){
          setBadgeColor('warning');
        }
        if(status == 'REJECT') {
          setBadgeColor('danger');
        }
        if(status == 'SOLD') {
          setBadgeColor('light');
        }
        if(status == 'CLOSED') {
          setBadgeColor('dark');
        }
        if(status == 'EXPIRED') {
          setBadgeColor('danger');
        }
      },[status]);

    return  ( 
        <div className={`${styles.productItem} text-body text-center position-relative`} >
            <Link 
                to={`/product/${props.data.id}/${props.data.title.replace(/\s+/g, '-')}`} 
                className={`text-decoration-none text-body ${styles.productImage} ${status !== 'APPROVE' && status !== 'SOLD' && status !== 'CLOSED' && status !== 'EXPIRED' ? 'disabledbutton' : ''}`}
            >
                {
                    props.data.status != 'APPROVE' &&
                        <Badge 
                            className={`position-absolute ${badgeColor == 'light' && "text-dark"} customBadge smallBadge`} 
                            color={badgeColor}
                            >
                            {status}
                        </Badge>
                }
                <img   
                    className={`${styles.coverImage} img-fluid d-inline`} 
                    src={`${!props.data.image ? '/images.png' : `${process.env.REACT_APP_API_URL}${props.data.image}`}`} />
            </Link>
            {
                props.isWishlist && <Favorite  isOnlyIcon={true} productId={props.data.id} />
            }
            <div  className={`px-3 py-2 text-start ${styles.detailBox}`}>
                <Link to={`/product/${props.data.id}/${props.data.title.replace(/\s+/g, '-')}`} className={`text-decoration-none text-body ${status !== 'APPROVE' && status !== 'SOLD' && status !== 'CLOSED' && status !== 'EXPIRED' ? 'disabledbutton' : ''}`} >  
                    <div className={`py-1 ${styles.title}`}>{props.data.title}</div>
                </Link>
                {
                    props.data.state_id &&
                        <div className={`${status !== 'APPROVE' && status !== 'SOLD' && status !== 'CLOSED' && status !== 'EXPIRED' ? 'disabledbutton' : ''} d-flex align-items-center`}>
                            <i className="bi bi-geo-alt me-2 text-primary" ></i>
                            <div className={`py-1 ${styles.productDetail}`}>
                                 {
                                    props.data.state_id && props.data.state.title
                                }
                               {
                                    props.data.state_id && props.data.city_id ? ', ' : ''
                                }
                                {
                                    props.data.city_id && props.data.city.title
                                }
                            </div>
                        </div>
                }
                {
                    expireDate &&
                        <div 
                            className={`${status !== 'APPROVE' && status !== 'SOLD' && status !== 'CLOSED' && status !== 'EXPIRED' ? 'disabledbutton' : ''} d-flex align-items-center`}>
                            <i className="bi bi-calendar-week me-2 text-primary" ></i>
                            <div className={`py-1 ${styles.productDetail}`}>{expireDate}</div>
                        </div>
                }
            </div>
            <hr className='border-dark border-opacity-25 my-2' />
            <div 
                className={`px-3 py-2 d-flex justify-content-between ${status !== 'APPROVE' && status !== 'SOLD' && status !== 'CLOSED' && status !== 'EXPIRED' ? 'disabledbutton' : ''}`}>
                <div className={`py-1 ${styles.price}`}>
                    {'$'}{
                        props.data.discount > 0 ? props.data.discount_price : props.data.price
                    }
                </div>
                {
                    props.data.discount > 0 && 
                        <div 
                            className={`py-1 text-decoration-line-through ${status !== 'APPROVE' && status !== 'SOLD' && status !== 'CLOSED' && status !== 'EXPIRED' ? 'disabledbutton' : ''}`}>
                            {'$'}{props.data.price}
                        </div>
                }
            </div>
        </div>
    )
}


export default Product;
